<script>
import { Errors } from 'form-backend-validation'
import { uniqBy, groupBy } from 'lodash'
export default {
  name: 'studentScoreEntry',
  props: ['value', 'studentScoreAndComponent', 'gradeSubjects', 'validate'],
  data() {
    return {
      errors: new Errors(),
      reload: false,
      model: {},
      newSubjects: [],
      subjectItemList: {}
    }
  },
  computed: {
    subjectIdValue: () => score => {
      if (score === undefined) return null
      if (score.length) {
        return score[0].new_sc_subject_id
      }
      return null
    },
    getSubjectItemList: vm => items => {
      if (items !== undefined) {
        return vm.subjectItemList[items.new_sc_subject_id]
      }
      return []
    }
  },
  created() {
    this.model = this.value
    this.createNewSubjectList()
    this.createSubjectItem()
  },
  methods: {
    createNewSubjectList() {
      const subjects = uniqBy(
        this.gradeSubjects.map(el => ({
          subject_id: el.subject_id,
          subject_name_native: el.subject_name_native
        })),
        'subject_id'
      )
      this.newSubjects = subjects
    },
    createSubjectItem() {
      const subjectItem = uniqBy(
        this.gradeSubjects.map(el => ({
          ux: `${el.subject_comp_id}_${el.subject_id}`,
          subject_id: el.subject_id,
          comp_item_name: el.comp_item_name,
          subject_comp_id: el.subject_comp_id
        })),
        'ux'
      )
      this.subjectItemList = groupBy(subjectItem, 'subject_id')
    },
    onSubjectChange(event, subjectItems) {
      const subjectId = event.target.value
      subjectItems.forEach(el => {
        // find subject
        const subjects = this.gradeSubjects.filter(
          s => s.subject_id === parseInt(subjectId)
        )
        if (subjects.length) {
          el.new_sc_subject_id = subjects[0].subject_id
          // find subject component
          const components = subjects.filter(
            com => com.comp_item_name === el.comp_item_name
          )

          if (components.length) {
            el.new_sc_item_subject_comp_id = components[0].subject_comp_id
          } else {
            el.new_sc_item_subject_comp_id = ''
          }
        } else {
          el.new_subject_id = ''
          el.new_sc_item_subject_comp_id = ''
        }
      })
      this.reload = true
      this.$nextTick(() => (this.reload = false))
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
<template>
  <div v-if="!reload">
    <h3 class="ts-uppercase ts-font-semibold ts-text-blue-800 ts-text-base">
      {{ $t('studentTransfer.scoreEntry') }}
    </h3>
    <div class="ts-mt-2 ts-grid ts-grid-cols-2 ts-gap-3">
      <div
        v-for="(score, subject) in model.scoreEntries"
        :key="subject"
        class="ts-border-t ts-py-2"
      >
        <div class="ts-flex ts-items-center ts-space-x-3">
          <div style="width: 12.4rem;">
            <h4 class="ts-text-base">{{ subject }}</h4>
          </div>
          <i class="fas fa-arrow-right"></i>
          <select
            :value="subjectIdValue(score)"
            class="ts-outline-none"
            @change="event => onSubjectChange(event, score)"
          >
            <option :value="undefined">--select--</option>
            <option
              v-for="(sub, index) in newSubjects"
              :key="index"
              :value="sub.subject_id"
              >{{ sub.subject_name_native }}</option
            >
          </select>
        </div>
        <div
          v-for="(items, index) in score"
          class="ts-border-t ts-p-2"
          :key="index"
        >
          <div class="ts-flex ts-items-center ts-space-x-3">
            <div style="width: 11.9rem;">
              <p class="ts-mb-0 ts-text-blue-600 ts-font-semibold">
                {{ items.comp_item_name }}
              </p>
            </div>
            <i class="fas fa-arrow-right"></i>
            <select
              v-model="items.new_sc_item_subject_comp_id"
              class="ts-outline-none"
            >
              <option value="">--select--</option>
              <option
                v-for="(itemList, index) in getSubjectItemList(items)"
                :key="index"
                :value="itemList.subject_comp_id"
                >{{ itemList.comp_item_name }}</option
              >
            </select>
          </div>
          <div
            class="ts-text-red-500"
            v-if="
              errors.has(
                `scoreEntries.${subject}.${index}.new_sc_item_subject_comp_id`
              )
            "
          >
            {{
              errors.first(
                `scoreEntries.${subject}.${index}.new_sc_item_subject_comp_id`
              )
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
select {
  /* Remove default arrow in IE/Edge */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
</style>
